export default __webpack_public_path__ + "static/media/404-error.96cfe34c.svg";